import React, { useEffect, useState } from "react";
import styles from "./dashboard.module.scss";
import { useNavigate } from "react-router-dom";
import { useFetchPartnerDetails } from "../../../../hooks/partnerHook/usePartner";
import { FaPlayCircle, FaPauseCircle } from "react-icons/fa";
import { FaCircleNotch } from "react-icons/fa6";
import { TiArrowForwardOutline } from "react-icons/ti";
import feedbackImage from "../../../../assets/images/extras/feedback.png";
import trustedSeller from "../../../../assets/images/extras/trustedSeller.png";
import userImage1 from "../../../../assets/images/DashboardImages/UserAvatar.png";
import userImage2 from "../../../../assets/images/DashboardImages/UserAvatar.png";
import userImage3 from "../../../../assets/images/DashboardImages/UserAvatar.png";
import videoImage from "../../../../assets/images/DashboardImages/videoImage.png";
import AerialBorneShorts from "../../../../components/AerialBorneShorts/AerialBorneShorts";
import { useDispatch, useSelector } from "react-redux";
import FeedbackForm from "../../../../components/FeedbackForm/FeedbackForm";
import { openFeedback } from "./../../../../store/Partner/modalSlice";
import FeedbackBanner from "../../../../components/RequestFeedback/RequestFeedback";
import TipsSection from "../../../../components/TipsSection/TipsSection";


function Dashboard() {
  const showFeedback = useSelector((state) => state.modal.showFeedback);
  const dispatch = useDispatch();
  const handleOpenFeedback = () => {
    dispatch(openFeedback());
  };
  const navigate = useNavigate();
  const userDetails = useSelector((state) => state.partner.user);
  const videoFiles = ["shorts1.mp4", "shorts2.mp4", "shorts3.mp4"];
  const [playingVideos, setPlayingVideos] = useState(
    Array(videoFiles.length).fill(false)
  );
  const [animatingIndex, setAnimatingIndex] = useState(null);
  const [activeIndex, setActiveIndex] = useState(1);
  const [paused, setPaused] = useState(false);
  const { data: partnerData, isLoading, isError } = useFetchPartnerDetails();
  const partner = partnerData?.partner || {};
   

  const showGoogleMap = useSelector((state) => state.modal.showGoogleMap);
  
  const testimonials = [
    {
      id: 1,
      name: "Alice Johnson",
      role: "Photographer",
      image: userImage1,
      comment:
        '"Quis aute aute enim veniam aliquip consectetur nisi esse magna ea ex irure excepteur ea irure non aliqua officia aliqua."',
    },
    {
      id: 2,
      name: "Michael Smith",
      role: "Drone Pilot",
      image: userImage2,
      comment:
        '"Quis aute aute enim veniam aliquip consectetur nisi esse magna ea ex irure excepteur ea irure non aliqua officia aliqua."',
    },
    {
      id: 3,
      name: "Sarah Lee",
      role: "Videographer",
      image: userImage3,
      comment:
        '"Quis aute aute enim veniam aliquip consectetur nisi esse magna ea ex irure excepteur ea irure non aliqua officia aliqua."',
    },
  ];

  useEffect(() => {
    if (testimonials.length > 1 && !paused) {
      const interval = setInterval(() => {
        setActiveIndex((prevIndex) => (prevIndex + 1) % testimonials.length);
      }, 3000);

      return () => clearInterval(interval);
    }
  }, [testimonials.length, paused]);

 

  const handleVideoClick = (index) => {
    const videos = document.querySelectorAll("video");
    const newPlayingVideos = playingVideos.map((_, i) => i === index);

    videos.forEach((video, i) => {
      if (i !== index) {
        video.pause();
      }
    });
    const videoElement = document.getElementById(`video-${index}`);

    if (videoElement.paused) {
      videoElement.play();
      newPlayingVideos[index] = true;
      setAnimatingIndex(index);
      setTimeout(() => setAnimatingIndex(null), 1000);
    } else {
      videoElement.pause();
      newPlayingVideos[index] = false;
    }

    setPlayingVideos(newPlayingVideos);
  };

  const updatePlayingVideos = (index, isPlaying) => {
    setPlayingVideos((prev) =>
      prev.map((playing, i) => (i === index ? isPlaying : playing))
    );
  };

  const completedSteps = {
    equipments:
      Array.isArray(partner.equipment) && partner.equipment.length > 0,
    certificates: Array.isArray(partner.licence) && partner.licence.length > 0,
    specialisedCertificates:
      Array.isArray(partner.certificate) &&
      partner.certificate.some((cert) => cert.specialisation_category),
    kyc: partner.kyc !== null && partner.kyc !== undefined,
    social:
      partner.socialDetails !== null && partner.socialDetails !== undefined,
    services: Array.isArray(partner.services) && partner.services.length > 0,
  };

  const totalCompleted = Object.values(completedSteps).filter(Boolean).length;

  const steps = [
    {
      id: 1,
      icon: <FaCircleNotch />,
      text: "Add your Equipments",
      path: "/dashboard/equipments",
      completed: completedSteps.equipments,
    },
    {
      id: 2,
      icon: <FaCircleNotch />,
      text: "Add your drone pilot license",
      path: "/dashboard/licenses",
      completed: completedSteps.certificates,
    },
    {
      id: 3,
      icon: <FaCircleNotch />,
      text: "Add specialised certificates you've",
      path: "/dashboard/certificates",
      completed: completedSteps.specialisedCertificates,
    },
    {
      id: 4,
      icon: <FaCircleNotch />,
      text: "Complete your KYC",
      path: "/dashboard/kycdocuments",
      completed: completedSteps.kyc,
    },
    {
      id: 5,
      icon: <FaCircleNotch />,
      text: "Link Social Profile",
      path: "/dashboard/social",
      completed: completedSteps.social,
    },
    {
      id: 6,
      icon: <FaCircleNotch />,
      text: "Add services and start selling",
      path: "/dashboard/services",
      completed: completedSteps.services,
    },
  ];
  if (isLoading) return <p>Loading...</p>;
  if (isError) return <p>Error loading partner data</p>;

  return (
    <>
      <div className={styles.dashboardPage}>
        <div className={styles.getReadyContainer}>
          <h2 className={styles.getReadyTitle}>Get ready to sell</h2>
          <p className={styles.getReadySubtitle}>
            Use this guide to get your profile up and running.
          </p>
          <div className={styles.progressBox}>
            <p className={styles.progressText}>{totalCompleted}/6 Completed</p>
          </div>
          <div className={styles.stepsContainer}>
            {steps.map((step) => (
              <div
                key={step.id}
                className={`${styles.stepItem} ${
                  step.completed ? styles.completedStep : ""
                }`}
                onClick={() => navigate(step.path)}
              >
                <div className={styles.stepIcon}>{step.icon}</div>
                <p className={styles.stepText}>{step.text}</p>
              </div>
            ))}
          </div>
          {/* <div className={styles.requestCallBackSection}>
          <div className={styles.requestCallBackText}>
            <h2 className={styles.requestTitle}>Request a call back</h2>
            <p className={styles.requestSubtitle}>
              Know more about how Aerial Borne can help you grow your business.
            </p>
            <button
              className={styles.requestButton}
              onClick={() => navigate("/dashboard/callback")}
            >
              <TiArrowForwardOutline className={styles.buttonIcon} />
            </button>
          </div>

          <div className={styles.requestCallBackImage}>
            <img src={womanImage} alt="Request a Call Back" />
          </div>
        </div> */}

          <FeedbackBanner
            modalFunction={handleOpenFeedback}
            heading="Share your feedback with Aerial Borne"
            para=" Participate in an Aerial Borne research study to help us drive
            Aerial Borne’s full potential for all users!"
            buttonText="Participate now"
            imgSrc={feedbackImage}
          />

          <FeedbackBanner
            modalFunction={handleOpenFeedback}
            heading="Add reviews from your past projects"
            para="Verified users can connect reviews from projects outside of Aerial Borne to give that extra boost of confidence."
            buttonText="Add external Review"
            imgSrc={trustedSeller}
          />
          <TipsSection />
          <AerialBorneShorts />
        </div>
      </div>

      {showFeedback && <FeedbackForm />}
     
    </>
  );
}

export default Dashboard;

{
  /* <div className={styles.testimonialsSection}>
          <h2 className={styles.testimonialsTitle}>
            What Our Users Are Saying
          </h2>

          <div
            className={styles.testimonialsContainer}
            onMouseEnter={() => setPaused(true)}
            onMouseLeave={() => setPaused(false)}
          >
            {testimonials.map((testimonial, index) => (
              <div
                key={testimonial.id}
                className={`${styles.testimonialCard} ${
                  index === activeIndex ? styles.activeCard : ""
                }`}
              >
                <div className={styles.userInfo}>
                  <img
                    src={testimonial.image}
                    alt={testimonial.name}
                    className={styles.userImage}
                  />
                  <div>
                    <h3 className={styles.userName}>{testimonial.name}</h3>
                    <p className={styles.userRole}>{testimonial.role}</p>
                  </div>
                </div>
                <p className={styles.comment}>{testimonial.comment}</p>
              </div>
            ))}
          </div>
          <div className={styles.testimonialIndicators}>
            {testimonials.map((_, index) => (
              <div
                key={index}
                className={`${styles.indicatorDot} ${
                  index === activeIndex ? styles.activeDot : ""
                }`}
              ></div>
            ))}
          </div>
        </div> */
}

{
  /* <div className={styles.shortsSection}>
          <h2 className={styles.shortsTitle}>Aerial Borne Shorts</h2>

          <div className={styles.shortsContainer}>
            {videoFiles.map((video, index) => (
              <div key={index} className={styles.shortVideoWrapper}>
                {playingVideos[index] ? (
                  animatingIndex === index ? (
                    <FaPauseCircle
                      className={`${styles.playPauseIcon} ${styles.animateIcon}`}
                    />
                  ) : null
                ) : (
                  <FaPlayCircle
                    className={styles.playPauseIcon}
                    onClick={() => handleVideoClick(index)}
                  />
                )}
                {!playingVideos[index] && (
                  <img
                    src={videoImage}
                    alt="Video Thumbnail"
                    className={styles.videoThumbnail}
                    onClick={() => handleVideoClick(index)}
                  />
                )}
                <video
                  id={`video-${index}`}
                  className={styles.shortVideo}
                  src={require(`../../../../assets/images/DashboardImages/${video}`)}
                  controls
                  onClick={() => handleVideoClick(index)}
                  onEnded={() => updatePlayingVideos(index, false)}
                  disablePictureInPicture
                  controlsList="nodownload nofullscreen"
                />
              </div>
            ))}
          </div>
        </div> */
}
